export default __webpack_public_path__ + "static/media/TechAlgo.a5b82c31.png";